import styled from 'styled-components';

export const BreachPlusCancelInfoContainer = styled.div`
  text-align: center;
  padding: 3rem 0;

  ${({ theme: { media } }) =>
    media(
      '20',
      `
    text-align: left;
  `
    )};
`;

export const TextButton = styled.button`
  background: none;
  border: none;
  color: #2a75dc;
  font-family: 'Roboto';
  font-weight: 400;
  line-height: 28px;
  font-size: 1rem;
  text-decoration: none;
  margin: 20px 0px;
  cursor: pointer;
  padding: 0;
`;
